import { useTranslation } from 'react-i18next';
import { upperFirst } from 'lodash';
import { CloseOutlined } from '@ant-design/icons';
import { Form, FormInstance } from 'antd';
import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';

import { ConnectionListContainer } from './ConnectionList.styles';

const ConnectionList = observer(({ field, form }: { form: FormInstance; field: string }) => {
  const { t } = useTranslation();
  const { stationStore, pidEditStore } = useStores();
  const fieldName = `connect${upperFirst(field)}`;
  const selectedValues = Form.useWatch(fieldName, { form, preserve: true }) || [];

  const onRemoveConnection = (value: string) => () => {
    const newSelectedValues = selectedValues?.filter(v => v !== value);
    form.setFieldValue(fieldName, newSelectedValues);
    pidEditStore.setAssetConnectionsInEditIds([]);
  };

  const onMouseEnter = (value: string) => () => {
    pidEditStore.setAssetConnectionsInEditIds([value]);
  };

  const onMouseLeave = () => {
    pidEditStore.setAssetConnectionsInEditIds([]);
  };

  if (!selectedValues?.length) return null;

  return (
    <ConnectionListContainer>
      <span className="label">
        {t(field)}
        {selectedValues?.length > 0 ? ` (${selectedValues.length})` : ''}
      </span>
      {selectedValues?.map(value => (
        <div key={value} className="connection-item" onMouseEnter={onMouseEnter(value)} onMouseLeave={onMouseLeave}>
          {stationStore.getDeviceById(value)?.name}
          <CloseOutlined className="close-icon" onClick={onRemoveConnection(value)} />
        </div>
      ))}
    </ConnectionListContainer>
  );
});

export default ConnectionList;
